import { IABExperiment } from '@cian/api-models/monolith-python/cian-api/site/v1/get-ab-experiments';
import { ImageNone } from '@cian/image-none-component';
import { IStyleConfig, mergeStyles } from '@cian/utils';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { MICRODATA_EXPERIMENT_ALL_GROUPS, MICRODATA_EXPERIMENT_NAME } from '../../../experiments/experiment';
import { IOfferPhoto } from '../../../types/offer';
import { Gallery, GalleryImage } from '../gallery';

const style = require('./index.css');

export interface IPhotoProps {
  photos: IOfferPhoto[];
  containerStyle?: IStyleConfig;
  controlButtonsFullHeight?: boolean;
  galleryControlsHidden: boolean;
  hasLayoutPhoto?: boolean;
  layoutPhotoStyle?: string;
  onSlideChanged?(): void;
  /** Использовать ли в галерее фото более высокого качества */
  useThumbnail2Url?: boolean;
}

export interface IPhotoContext {
  experiments: IABExperiment[];
}

export interface IPhotoState {
  photos: React.ReactChild[];
}

export class Photo extends React.Component<IPhotoProps, IPhotoState> {
  public context: IPhotoContext;

  public static contextTypes = {
    experiments: PropTypes.array,
  };

  public constructor(props: IPhotoProps) {
    super(props);

    const defaultPhoto = Math.max(this.props.photos.findIndex((photo) => photo.isDefault), 0);

    this.state = {
      photos: props.photos.map((photo, index) => <GalleryImage
        key={index}
        src={props.useThumbnail2Url ? photo.thumbnail2Url : photo.thumbnailUrl}
        isLayout={this.props.hasLayoutPhoto && defaultPhoto === index}
        layoutPhotoStyle={this.props.layoutPhotoStyle}
        alt=""
      />),
    };
  }

  public render() {
    const defaultPhoto = Math.max(this.props.photos.findIndex((photo) => photo.isDefault), 0);
    const defaultPhotoImg = this.props.photos[defaultPhoto];
    const defaulPhotoUrl = defaultPhotoImg
      ? defaultPhotoImg.fullUrl
      : '';

    const microData = MICRODATA_EXPERIMENT_ALL_GROUPS.includes(this.getExperimentGroup())
      ? {
        itemScope: true,
        itemType: 'http://schema.org/ImageObject',
      }
      : {};

    return (
      <div {...microData} {...mergeStyles(style['container'], this.props.containerStyle)}>
        <span {...{ itemProp: 'url', content: defaulPhotoUrl }} />
        {this.props.photos.length > 0 && <Gallery
          defaultIndex={defaultPhoto}
          controlsHidden={this.props.galleryControlsHidden}
          onSlideChanged={this.props.onSlideChanged}
          controlButtonsFullHeight={this.props.controlButtonsFullHeight}
        >
          {this.state.photos}
        </Gallery>}
        {this.props.photos.length === 0 && <ImageNone containerStyle={style['noImage']} />}
      </div>
    );
  }

  private getExperimentGroup() {
    return this.context.experiments.reduce((group, experiment) => {
      if (experiment.name === MICRODATA_EXPERIMENT_NAME) {
        // tslint:disable-next-line: no-parameter-reassignment
        group = Number(experiment.abGroup);
      }

      return group;
    }, 0);
  }
}
